<template>
  <div class="zt-content-tooltip" ref="ztContentTooltip" v-bind="$attrs" v-on="$listeners" @mouseenter="_mouseEnter" @mouseleave="_mouseLeave" @click="_mouseClick">
    <transition name="zt-tooltip-fade">
      <div
        v-if="active"
        v-show="activeTooltip"
        ref="ztTooltip"
        class="zt-tooltip absolute left-0 top-0 block h-auto rounded text-zt-xs"
        :class="[
          bgColor,
          isOutlined,
          positionClassIndicator,
          { 'indicator-tooltip': indicatorTooltip },
          { 'zt-tooltip-shadow': shadow },
        ]"
        :style="styleConfig"
      >
        <h4 v-if="title">{{ title }}</h4>
        {{ text }}
        <div>
          <slot name="body" />
        </div>
      </div>
    </transition>
    <slot />
  </div>
</template>

<script>
import utils from '../../../../utils/helpers'

export default {
  name: 'ztTooltip',
  inheritAttrs: false,
  props: {
    text: { type: [String, Number], default: null },
    title: { type: [String, Number], default: null },
    position: { type: String, default: 'top' },
    color: { type: String, default: null },
    active: { type: [Boolean], default: true },
    outlined: { type: Boolean, default: false },
    clickable: { type: Boolean, default: false },
    shadow: { type: Boolean, default: false },
  },
  data() {
    return {
      activeTooltip: false,
      cordsContent: {},
      indicatorTooltip: false,
      alterPosition: null,
    }
  },
  computed: {
    bgColor() {
      let colorLevel = this.color === 'primary' || this.color === 'secondary' ? '-200' : ''
      if (this.color && this.outlined) {
        return `bg-zt-white text-zt-${this.color}${colorLevel}`
      } else if (this.color) {
        return `text-zt-white bg-zt-${this.color}` + colorLevel
      } else if (this.color === 'white') return `bg-zt-white`
      return 'bg-zt-dark-500 text-zt-white'
    },
    styleConfig() {
      return {
        left: this.cordsContent.left,
        top: this.cordsContent.top,
        width: 'auto',
        zIndex: 40000,
      }
    },
    positionClassIndicator() {
      return `zt-tooltip-${this.alterPosition || this.position}`
    },
    isOutlined() {
      let colorLevel = this.color === 'primary' || this.color === 'secondary' ? '-200' : ''
      return this.outlined ? `border-zt-xs border-zt-${this.color}${colorLevel}` : ''
    }
  },
  methods: {
    async _mouseEnter(event) {
      if (this.active && !this.clickable) {
        this.activeTooltip = true
        await this.$nextTick()
        utils.insertContent(this.$refs.ztTooltip)
        this.positionContent()
        this.$emit('mouseenter', event)
      }
    },
    _mouseLeave(event) {
      if (!this.clickable) {
        this.activeTooltip = false
        if (this.$refs.ztTooltip) {
          utils.removeContent(this.$refs.ztTooltip)
        }
        this.$emit('mouseleave', event)
      }
    },
    async _mouseClick(event) {
      if (this.clickable) {
        this.$emit('focus', event)
        this.activeTooltip = true
        utils.insertContent(this.$refs.ztTooltip)
        await this.$nextTick()
        this.positionContent()
        document.addEventListener('click', this._mouseBlur)
        event.stopPropagation()
      }
    },
    _mouseBlur() {
      if (this.$refs.ztTooltip && this.activeTooltip) {
        utils.removeContent(this.$refs.ztTooltip)
        this.activeTooltip = false
        document.removeEventListener('click', this._mouseBlur)
      }
    },
    positionContent() {
      this.indicatorTooltip = false
      this.alterPosition = null
      let contentTooltip = this.$refs.ztContentTooltip
      let toolTip = this.$refs.ztTooltip
      let elementZt = contentTooltip.closest('.zt-content-tooltip')
      let scrollTopZt = window.scrollY || document.documentElement.scrollTop
      let topPos = elementZt.getBoundingClientRect().top + scrollTopZt - toolTip.clientHeight - 4
      let leftPos = elementZt.getBoundingClientRect().left - toolTip.clientWidth / 2 + elementZt.clientWidth / 2
      let widthZt = elementZt.clientWidth

      if (this.position === 'bottom') {
        topPos = elementZt.getBoundingClientRect().top + scrollTopZt + elementZt.clientHeight + 4
      }
      if (this.position === 'left') {
        leftPos = elementZt.getBoundingClientRect().left - toolTip.clientWidth - 4
        topPos = elementZt.getBoundingClientRect().top + scrollTopZt + elementZt.clientHeight / 2 - toolTip.clientHeight / 2
        if (Math.sign(leftPos) === -1) {
          leftPos = elementZt.getBoundingClientRect().left
          topPos = elementZt.getBoundingClientRect().top + elementZt.clientHeight + 4
          this.alterPosition = 'bottom'
          this.indicatorTooltip = true
        }
      }
      if (this.position === 'right') {
        leftPos = elementZt.getBoundingClientRect().left + elementZt.clientWidth + 4
        topPos = elementZt.getBoundingClientRect().top + scrollTopZt + elementZt.clientHeight / 2 - toolTip.clientHeight / 2
        if (window.innerWidth - (leftPos + toolTip.clientWidth) <= 20) {
          leftPos = elementZt.getBoundingClientRect().left + toolTip.clientWidth / 2 - 10
          topPos = elementZt.getBoundingClientRect().top + scrollTopZt + elementZt.clientHeight + 4
          this.alterPosition = 'bottom'
          this.indicatorTooltip = true
        }
      }
      this.cordsContent = {
        left: `${leftPos}px`,
        top: `${topPos}px`,
        width: `${widthZt}px`,
      }
    }
  },
  beforeDestroy() {
    utils.removeContent(this.$refs.ztTooltip)
    this.activeTooltip = false
    document.removeEventListener('click', this._mouseBlur)
  }
}
</script>

<style scoped lang="css" src="../../../../../src/styles/components/ztTooltip.css" />


